
import { defineComponent, computed, onMounted, inject } from "vue";
  import { useI18n } from 'vue-i18n';
  import { useStore } from 'vuex';
  import { useRouter, useRoute } from 'vue-router';
  import { MenuComponent } from '@/assets/ts/components';

  export default defineComponent({
    name: 'header-menu',
    components: {},
    mounted() {
      const vm = this;
      window.addEventListener('scroll', vm.scrollHeader);

      // /* REMOVE MENU MOBILE */
      const navLink = document.querySelectorAll('.nav_link');
      navLink.forEach(n => n.addEventListener('click', vm.linkAction));

    },
    methods: {
      linkAction() {
        const navMenu: any = document.getElementById('nav-menu');
        // When we click on each nav_link, we remove the show-menu class
        navMenu.classList.remove('show-menu');
      },
      scrollHeader() {
        const nav: any = document.getElementById('header');
        // When the scroll is greater than 200 viewport height, add the scroll-header class to the header tag
        if (window.scrollY >= 80) nav.classList.add('scroll-header');
        else nav.classList.remove('scroll-header');
      },
    },
    setup() {
      const i18n: any = useI18n();
      const router = useRouter();
      const route = useRoute();
      const store = useStore();
      const helpers: any = inject("helpers");

      onMounted(() => {
        MenuComponent.reinitialization();
      });

      i18n.locale.value = localStorage.getItem('lang')
        ? (localStorage.getItem('lang') as string)
        : 'en';

      const countries = {
        en: {
          flag: 'media/flags/united-states.svg',
          name: 'english',
        },
        ar: {
          flag: 'media/flags/egypt.svg',
          name: 'arabic',
        },
      };

      const setLang = (lang) => {
        localStorage.setItem('lang', lang);
        i18n.locale.value = lang;
        location.reload();
      };

      const currentLanguage = (lang) => {
        return i18n.locale.value === lang;
      };

      const currentLanguageLocale = computed(() => {
        return countries[i18n.locale.value];
      });

      const goToRegister = () => {
        router.push({ name: 'login_page' });
      };
      const goToAccount = () => {
        router.push({ name: 'profile_page' });
      };
      const goToPrograms = () => {
        router.push({ name: 'all_programs_page' });
      };
      const goToHome = () => {
        router.push({ name: 'dashboard' });
      };
      const logout = () => {
        store.dispatch('moduleAuth/logout').then(() => {
          location.reload();
        });
      };

      const getTrainerProgram = (id) => {
        // loading = true;
        store.dispatch("modulePrograms/findProgramDetails", {id: id})
          .then(({data}) => {
            // loading = false;
            let response = data.data;
            if (response.submissionStatus == 'NOT_COMPLETED') {
              if (response.formJsonSubmission && response.formJsonSubmission.formSubmissions) {
                router.push({ name: 'apply_program_page', params: { id: response._id } });
                return;
              }
              router.push({ name: 'show_program_page', params: { id: response._id } });
              return;
            }
            if (response.submissionStatus == 'COMPLETED') {
              router.push({ name: 'success_program_page', params: { id: response._id } });
              return;
            }

          })
          .catch((response) => {
            // loading = false;
            helpers.handleResponse(response, i18n, router, store, {});
          });
      };

      return {
        getTrainerProgram,
        goToRegister,
        goToAccount,
        goToPrograms,
        goToHome,
        logout,
        route,
        store,
        setLang,
        currentLanguage,
        currentLanguageLocale,
        countries,
      };
    },
  });
